// src/components/admin/AdminClientNewPage.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  Container, Typography, Paper, Box, Breadcrumbs, Link,
  Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AdminClientForm from './AdminClientForm';
import { adminApi } from '../../api/adminApi';

const pageVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -20 }
};

const pageTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 0.6
};

export default function AdminClientNewPage() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleCreateClient = async (data) => {
    setSaving(true);
    setError('');
    
    try {
      await adminApi.createClient(data);
      alert('تم إنشاء العميل بنجاح!');
      navigate('/admin/clients');
    } catch (error) {
      console.error('Failed to create client:', error);
      setError(error.message || 'فشل في إنشاء العميل');
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (window.confirm('هل أنت متأكد من إلغاء إنشاء العميل؟ سيتم فقدان جميع البيانات المدخلة.')) {
      navigate('/admin/clients');
    }
  };

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Container maxWidth="lg">
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          {/* Breadcrumbs */}
          <Breadcrumbs sx={{ mb: 2 }}>
            <Link
              color="inherit"
              href="/admin/clients"
              onClick={(e) => {
                e.preventDefault();
                navigate('/admin/clients');
              }}
              sx={{ 
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' }
              }}
            >
              العملاء
            </Link>
            <Typography color="text.primary">إضافة عميل جديد</Typography>
          </Breadcrumbs>

          <Typography variant="h4" component="h1" fontWeight="700" gutterBottom>
            إضافة عميل جديد
          </Typography>
          <Typography variant="body1" color="text.secondary">
            إنشاء حساب عميل جديد في النظام
          </Typography>
        </Box>

        {/* Error Alert */}
        {error && (
          <Alert 
            severity="error" 
            sx={{ mb: 3, borderRadius: 2 }}
            onClose={() => setError('')}
          >
            {error}
          </Alert>
        )}

        {/* Create Form */}
        <Paper sx={{
          p: 4,
          borderRadius: 3,
          boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
          border: '1px solid',
          borderColor: 'divider',
          background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)'
        }}>
          <AdminClientForm 
            onSubmit={handleCreateClient} 
            isEdit={false}
            saving={saving}
            onCancel={handleCancel}
          />
        </Paper>
      </Container>
    </motion.div>
  );
}
